<template>
  <div class="header">
    <div class="top">
      <img
        class="logo"
        src="../../../../assets/images/integration/logo.png"
        style="cursor: pointer"
        @click="goHome"
      />
      <div class="login111">
        <div class="button-box" @click="onRoleClick('mediate')">
          <div class="role-button">
            <img
              class="icon"
              src="../../../../assets/images/integration/tjy.png"
            />
            <span>调解员登录</span>
          </div>
        </div>
        <div class="button-box" @click="onRoleClick('gzc')">
          <div class="role-button">
            <img
              class="icon"
              src="../../../../assets/images/integration/gzy.png"
            />
            <span>公证员登录</span>
          </div>
        </div>
        <div class="button-box" @click="onRoleClick('party')">
          <div class="role-button">
            <img
              class="icon"
              src="../../../../assets/images/integration/dsr.png"
            />
            <span>当事人登录</span>
          </div>
        </div>
        <div class="button-box" @click="onRegister">
          <div class="role-button">
            <img
              class="icon"
              src="../../../../assets/images/integration/dsrzc.png"
            />
            <span>当事人注册</span>
            <!-- /verification/register -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onRoleClick(role) {
      this.$emit("onRoleLogin", {
        role,
      });
    },

    // 当事人注册
    onRegister() {
      location.href = process.env.VUE_APP_PARTY_REGISTER;
    },
    goHome() {
      location.href = process.env.VUE_APP_PARTY_INDEX;
    },
  },
  components: {},
};
</script>
    
<style lang="scss" scoped>
.header {
  background-color: #bd3126;
}
.top {
  font-size: 14px;
  width: 1280px;
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  height: 52px;
  background-color: #bd3126;
  .logo {
    height: 40px;
    cursor: pointer;
  }

  .login111 {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

.button-box {
  cursor: pointer;
  width: 118px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid #ffffff;
  color: #ffffff;
  background-color: #bd3126;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  margin-left: 12px;
  &:hover {
   scale: 1.05;
  }
}

.role-button {
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 20px;
    height: 20px;
    margin-right: 4px;
  }
}
</style>
    